import React from 'react';

export function ComponentLoading() {
  return (
    <div className='py-5'>
      <div className='loader' />
    </div>
  );
}
